angular.module('accessWebClient')
    .controller('SignFileInitModalController', [
        '$modalInstance',
        '$q',
        '$scope',
        '$translate',
        'flashMessagesService',
        'Esignature',
        function (
            $modalInstance,
            $q,
            $scope,
            $translate,
            flashMessagesService,
            Esignature
        ) {
            $scope.modal = $modalInstance.options;
            $scope.modal.loading = true;

            $modalInstance.opened
                .then(() => Esignature.getSettings({ node_uuid: $scope.node.uuid }).$promise)
                .then((settings) => {
                    let pdf = null;
                    let pdfError = null;

                    return (
                        settings.node_supports_notary_embedded_signatures ?
                            Esignature.getEmbeddedFile({ node_uuid: $scope.node.uuid }).$promise :
                            $q.resolve({ content: null })
                    )
                        .then(({ content }) => pdf = content)
                        .catch(({ message, data }) => {
                            if (settings.sequential_sign) {
                                throw new Error($translate.instant('esignature_sign_dialog_init_error'));
                            } else {
                                // We should proceed, even if we've failed to convert file to pdf.
                                // The file will be signed with electronic signature
                                pdfError = data && data.error && data.error.message || message;
                            }
                        })
                        .then(() => $modalInstance.close({
                            settings,
                            pdf,
                            pdfError
                        }));
                })
                .catch((error) => {
                    if (error.message) {
                        // This is only to handle errors occur during getEmbeddedFile request
                        flashMessagesService.add(error.message, flashMessagesService.ERROR);
                    }
                    $modalInstance.dismiss();
                })
                .finally(() => $scope.modal.loading = false);
        }
    ]);
